<div class="overlay-header print-ignore">
    <div class="overlay-logo">SIS K-12</div>
    <div class="overlay-title">{{dialogTitle}}</div>
    <div style="float:right; position:relative;padding-top:5px;">
       
    </div>
</div>
<mat-dialog-content>
  <div>
    <tyl-form-field style="width: 95%; height:120px;" label="Category">
      <textarea matInput style="height: 70px; resize: none;" [(ngModel)]="dataField.CategoryDescription"
        [disabled]="true" id="category" name="category"></textarea>
    </tyl-form-field>
  </div>
  <div>
    <tyl-form-field style="width: 95%; height:120px;" label="Teacher">
      <textarea matInput style="height: 20px; resize: none;" [(ngModel)]="userName" [disabled]="true" id="Teacher"
        name="Teacher"></textarea>
    </tyl-form-field>
  </div>
  <div style="width: 95%;height: 350px;">
    <tyl-kendo-html-editor style="height: 350px;" [inputValue]="dataField.CategoryNote" (myOutput)="GetChildData($event)">
    </tyl-kendo-html-editor>

  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <div class="flex-footer">
    <div class="flex-footer-right">
      <error-prompt [errorList]="errorList"></error-prompt>
      <tyl-button id="saveButton" (clickEvent)="saveClick()" image="save.png" label="Save"></tyl-button>
      <tyl-button id="cancelButton" image="cancel.png" label="Cancel" (clickEvent)="closeClick()"></tyl-button>
    </div>
  </div>
</mat-dialog-actions>